import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { toastHelper } from '../../../util/toastHelper'

const travel = ['Yes, driving', 'Yes, flying', 'Yes, other', 'No', 'Maybe']

function GuestsTravel({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>Do you have any guests traveling from afar?</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								{travel.map((label, idx) => (
									<ButtonCustom
                                        key={idx}
										data-cy={`${label}`}
										variant="pilled"
										style={{
											backgroundColor:
												weddingData?.guestTravelingAfar ===
												label
													? '#7ca6bd'
													: '#FFF',
											color:
												weddingData?.guestTravelingAfar ===
												label
													? '#FFF'
													: '#7ca6bd',
										}}
										onClick={() =>
											setWeddingData({
												...weddingData,
												guestTravelingAfar: label,
											})
										}
									>
										{label}
									</ButtonCustom>
								))}
							</div>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					data-cy="wizard-next"
					onClick={() => {
						if (!weddingData.guestTravelingAfar)
							return toastHelper(
								'Please select an option',
								'error'
							)
						handleNext()
					}}
				>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={1.6} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default GuestsTravel
